/**
 * Membership copy.
 *
 * The strings come from `locales/*.json` via `window.membershipStrings`, bridged in
 * `layout/theme.liquid`. Placeholders are `[token]`, matching the theme's existing convention
 * (see `products.product.booking_opens` and `window.accessibilityStrings`).
 *
 * Every membership-facing sentence goes through `text()` / `hours()` so the theme's other locales
 * translate it; feature code never writes English inline.
 */
(function () {
  'use strict';

  if (typeof window !== 'undefined' && window.MembershipStrings) return;

  const SINGULAR = 1;

  function getStrings() {
    return (typeof window !== 'undefined' && window.membershipStrings) || {};
  }

  function fill(template, tokens) {
    if (!template) return '';
    if (!tokens) return template;
    return Object.keys(tokens).reduce(
      (text, token) => text.split('[' + token + ']').join(String(tokens[token])),
      template
    );
  }

  /**
   * Resolved copy for a key, with `[token]` placeholders filled in.
   * Returns '' for an unknown key — callers check `window.MembershipStrings` first and skip
   * rendering entirely when it is absent, so there is no English fallback to keep here.
   */
  function text(key, tokens) {
    return fill(getStrings()[key], tokens);
  }

  /** Pluralised count, e.g. hours('hours', 1) → "1 hr", hours('hours', 2.5) → "2.5 hrs". */
  function hours(baseKey, count) {
    const suffix = Number(count) === SINGULAR ? 'One' : 'Other';
    return text(baseKey + suffix, { count: count });
  }

  if (typeof window !== 'undefined') {
    window.MembershipStrings = {
      text: text,
      hours: hours
    };
  }
})();
